export enum RccapUnacceptableXm {    
    InaccurateRecipientAvoids = 0,
    InaccurateDonorAntigens = 1,
    UnreportedSensitizationEvent = 2,
    NewAntibodyDevelopment = 3,
    ExmDenied = 4,
    DonorCryoUnavailable = 5,
    CryoXmDelayed = 6,
    ExmNotRequested = 7
}